import React from 'react';

const TabView = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`sm:w-max py-2 px-4 rounded-full text-sm font-medium transition-all flex items-center ${
            activeTab === tab.id
              ? "bg-[#3F3DA5] text-white"
              : "bg-white border border-[#C5C5E8] text-[#3F3DA5] hover:bg-[#C5C5E8]"
          }`}
        >
          {tab.icon && <span className="mr-2">{tab.icon}</span>}
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default TabView; 